import { instance } from "@/api/index";

export const listPrj = () => instance.get("/back/prj"); // 프로젝트 목록 조회
export const setPrj = payload => instance.post("/back/prj", payload);
export const delPrj = prjNo => instance.delete(`/back/prj/${prjNo}`);
export const modiPrj = (prjNo, payload) =>
  instance.put(`/back/prj/${prjNo}`, payload);
